import { InternalAxiosRequestConfig } from "axios";

import { useMainStore } from "@/store";

export const authInterceptor = (config: InternalAxiosRequestConfig) => {
  const { token } = useMainStore();

  if (token) {
    config.headers = config.headers || {};
    config.headers.Authorization = `Bearer ${token}`;
  }

  return config;
};
